import type { ActivityResponse } from '@stream-io/feeds-client'

export enum ValkTalkFeedType {
    valk = 'valk',
    hotel = 'hotel',
}

// Valkplanner's feed messages endpoint returns the Stream activity it created
export interface ValkTalkFeedMessageResource {
    activity: ActivityResponse
}

export interface ValkTalkPostImage {
    id: string
    url: string
    file?: File
}

export interface ValkTalkPostFormData {
    feedType: ValkTalkFeedType
    title: string
    text: string
    images: ValkTalkPostImage[]
}

export interface ValkTalkPostAuthor {
    id: string
    name?: string
}

export interface ValkTalkPost extends ValkTalkPostFormData {
    id: string
    author: ValkTalkPostAuthor
    createdAt: Date
}

export interface ValkTalkPostsQuery {
    feedTypes: ValkTalkFeedType[]
    month: Date
    // Only return posts by this (Stream) user
    authorId?: string
}

export interface ValkTalkPostsQueryResult {
    posts: ValkTalkPost[]
    // True when a feed has more posts in the month than were fetched
    hasMorePosts: boolean
}
